module.exports = __webpack_public_path__ + "img/20.fca0371e.png";